"use client";

import { Card, Col, Row } from "antd";
import React from "react";
import Chart from "react-apexcharts";

import tick from "../../../assets/icons/tick-circle-white.svg"
import calendar from "../../../assets/icons/calendar-tick.svg"
import strongbox from "../../../assets/icons/strong-box-white.png"

const icons = [
  {icon: calendar}, 
  {icon: tick}, 
  {icon: strongbox}
]

export default function CustomChainFlowAnalytics({ data, offices }) {
  //Test data
  // const data = {     total_users: 2,     task_completed: 2,     
  //   steps: [       {         name: "root canal0",         exact: 0,         cumulative: 2,         percent: 100       },       
  //     {         name: "root canal",         exact: 2,         cumulative: 2,         percent: 100       }     
  //   ]   
  // };
  const chartOptions = {
    chart: {
      type: 'bar',
      height: '100%',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 8,
        borderRadiusApplication: 'end',
        columnWidth: '60%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['transparent'],
    },
    xaxis: {
      categories: data.steps.map(item => item.name),
      title: {
        text: 'Step',
      },
    },
    yaxis: {
      title: {
        text: 'Value',
      },
    },
    tooltip: {
      enabled: true,
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5,
      },
    },
    colors: ['#8b5cf6'],
  };

  const cardArray = [
    {label: 'Total Started' , value: data.total_users},
    {label: 'Total Completed', value: data.task_completed},
  ]

  const chartSeries = [{
    name: 'Value',
    data: data.steps.map(item => item.percent)
  }];

  return (
    <Row gutter={22} >

      {/* Left side stats */}
      <Col xs={24} md={8}>
        {cardArray.map((stat, idx) => (
          <Card style={{marginBottom: (idx + 1) === 3 ? 0 : 14}} >
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <div>
                <span style={{ fontSize: '16px', fontWeight: 400, display: 'block' }}>
                  {stat.label}
                </span>
                <span style={{ fontSize: '24px', fontWeight: 500, color: '#6B43B5' }}>
                  {stat.value}
                </span>
              </div>
              <div style={{width: 56, height: 56, backgroundColor: '#6B43B5', borderRadius: '50%', display: "flex", justifyContent: 'center', alignItems: 'center'}}>
                <img src={icons[idx].icon} style={{width:34, height:34}}/>
              </div>

            </div>
          </Card>
        ))}
      </Col>
      {/* Right side chart */}
      <Col xs={24} md={16}>
        <Card style={{height: '100%'}}>
          {offices && offices.length === 0 ? 
            <span>Please, select at least one office.</span>  
          :   
            <Chart options={chartOptions} series={chartSeries} type="bar" height={300} width="100%" />
          }
        </Card>  
      </Col>

    </Row>
  );
}